import mainLogo from '../../images/Eurokraft/eurokraft_logo_main_Color.png';
import squareLogo from '../../images/Eurokraft/eurokraft_logo_square_small_Color.png';
import mainLogoWhite from '../../images/Eurokraft/eurokraft_logo_main_white.png';
import banner01 from '../../images/Eurokraft/eurokraft_banner_01.jpg';
import banner02 from '../../images/Eurokraft/eurokraft_banner_02.jpg';
import banner03 from '../../images/Eurokraft/eurokraft_banner_03.jpg';
import car123 from '../../images/Eurokraft/123_nivus.jpg';
import box123 from '../../images/Eurokraft/123_eurokraft.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Eurokraft',
    defaultStoreLink: 'pecas.eurokraft.com.br',
    defaultContactEmail: 'pecas.eurokraft@eurokraft.com.br',
    whatsappNumber: '22 99243 1813',
    CNPJname: 'Eurokraft Veiculos S.A.',
    CNPJ: '30.537.799/0001-10',
    CNPJaddress: 'Avenida Pres Costa e Silva 965 - Duas Pedras, Nova Friburgo RJ - 28630-000',
    launchDate: '01/09/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "EUROKRAFT VW NOVA FRIBURGO",
    ],
    
    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner03,

    box123: box123,
    car123: car123,
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Eurokraft</span>.',
    aboutUs: {
        title: 'Grupo Eurokraft — Tradição e qualidade Volkswagen na Serra',
        content: [
            'Com mais de 64 anos de história, o Grupo Eurokraft é referência em peças e serviços Volkswagen na região serrana -  RJ. Estamos em Nova Friburgo, Teresópolis e Petrópolis, sempre prontos pra te atender com excelência e agilidade.',
            'Nossas equipes são treinadas pela Volkswagen e oferecem o melhor em atendimento, peças genuínas e serviços especializados. Pode confiar: aqui você encontra tudo o que seu Volkswagen precisa, com qualidade e aquele atendimento que faz a diferença!'
        ],
        link: 'https://eurokraft.com.br/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupoeurokraft/',
        Facebook: 'https://www.facebook.com/Eurokraft/',
        LinkedIn: 'https://www.linkedin.com/company/grupo-carrera-veiculos/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}